export default "__VITE_ASSET__trCzUz_l__"